import {
  AuthService,
  IdentityAccessValueFactory,
  PolicyService,
  PolicyType,
  provideIdentityAccessPermissions,
} from '@finverity/identity-access';

import { SellerFinanceRequestCheckerPermissions } from './seller-finance-request-checker-permissions';

const SELLER_FINANCE_REQUEST_CHECKER_IDENTITY_ACCESS_FACTORY: IdentityAccessValueFactory<
  SellerFinanceRequestCheckerPermissions
> = (authService: AuthService, policyService: PolicyService) => {
  return {
    [SellerFinanceRequestCheckerPermissions.ViewInstruments]: true, // TODO: replace for normal Policies: policyService.hasPolicies('view_documents'),
    [SellerFinanceRequestCheckerPermissions.ViewInstrumentDetails]: policyService.hasPolicies(
      PolicyType.VIEW_INSTRUMENT_DETAILS
    ),
    [SellerFinanceRequestCheckerPermissions.ViewInstrumentAttachments]: policyService.hasPolicies(
      PolicyType.VIEW_DOCUMENTS
    ),
    [SellerFinanceRequestCheckerPermissions.ReviewInstruments]: policyService.hasPolicies(
      PolicyType.CONFIRM_INSTRUMENTS_SELLER_FINANCE_REQUEST_CHECKER
    ),
    [SellerFinanceRequestCheckerPermissions.RejectInstruments]: policyService.hasPolicies(
      PolicyType.REJECT_INSTRUMENTS_SELLER_FINANCE_REQUEST_CHECKER
    ),
  };
};

export const SELLER_FINANCE_REQUEST_CHECKER_IDENTITY_ACCESS_PROVIDER = provideIdentityAccessPermissions(
  SELLER_FINANCE_REQUEST_CHECKER_IDENTITY_ACCESS_FACTORY
);
